import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 9D9A73D2-0780-4141-95A3-CDFE21E6D4D6
 * name beer
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/beer.svg
 * tags
 * - Food / Drink 
 */
export const BeerIcon = createSvgIcon(<><path d="M4,2H19L17,22H6L4,2M6.2,4L7.8,20H8.8L7.43,6.34C8.5,6 9.89,5.89 11,7C12.56,8.56 15.33,7.69 16.5,7.23L16.8,4H6.2Z" /></>, 'BeerIcon');
export default BeerIcon